<script setup lang="ts">
import { getTransactionDisplayUserName, type TransactionTableRow } from '@peanuds/shared';

const { row } = defineProps<{ row: TransactionTableRow }>();
</script>

<template>
  <span class="cell-user">{{ getTransactionDisplayUserName(row) }}</span>
</template>
